<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-100vh">
      <div class="col-lg-5 col-md-8">
        <div class="card pl-2 text-white main-color mb-1">
          <div class="card-body h2">
            <span class="test-header-color h4" v-if="app_env !== 'production'">
              【テスト環境】
            </span>
            {{this.config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <b-overlay :show="overlayShow" rounded="sm">
              <div class="card-body">
                <h1>Login</h1>
                <div class="input-group mb-3 mt-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="person-fill"></b-icon>
                    </span>
                  </div>
                  <input class="form-control" :class="{'is-invalid' : validation.hasError('userId')}" type="text" placeholder="ユーザーID" ref="userId" v-model="userId">
                  <div class="invalid-feedback">
                    {{ validation.firstError('userId') }}
                  </div>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <b-icon icon="lock"></b-icon>
                    </span>
                  </div>
                  <input class="form-control" :class="{'is-invalid' : validation.hasError('password')}" type="password" placeholder="パスワード" ref="password" v-model="password">
                  <div class="invalid-feedback">
                    {{ validation.firstError('password') }}
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <b-button block variant="primary" @click.stop.prevent="login()">ログイン</b-button>
                  </div>
                </div>
              </div>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <CommonModal ref="commonModal" />
  </div>
</template>
<script>
import Vue from 'vue'
import LoginModel from '@/models/LoginModel'
import CommonModal from '@/components/CommonModal'
import SimpleVueValidation from 'simple-vue-validator'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'Login',
  components: {CommonModal},
  data () {
    return {
      overlayShow: false,
      userId: '',
      password: '',
      app_env: process.env.APP_ENV
    }
  },
  validators: {
    userId: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.login.userId.required)
    },
    password: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.login.password.required)
    }
  },
  methods: {
    login: async function () {
      let isError = await this.$validate()
        .then((success) => {
          return !success
        })

      if (isError) {
        return false
      }

      this.overlayShow = true

      let reqData = {
        userId: this.$refs.userId.value,
        password: this.$refs.password.value
      }

      const result = await LoginModel.postApi(this.$bvModal, reqData, () => {
        this.overlayShow = false
      })

      if (result.status === 'success') {
        if (sessionStorage.getItem('loginRedirect') === null) {
          this.$router.push('/project_list')
        } else {
          // ログイン後リダイレクトページがsessionに残っている場合
          const redirectPage = sessionStorage.getItem('loginRedirect')
          sessionStorage.removeItem('loginRedirect')
          this.$router.push(redirectPage)
        }
      }
    }
  },
  destroyed () {
    if (LoginModel.getStore()) {
      LoginModel.removeStore()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/Login.vue